import { render, staticRenderFns } from "./TimeSeriesLineChartCard.vue?vue&type=template&id=2bc15a37&scoped=true&"
import script from "./TimeSeriesLineChartCard.vue?vue&type=script&lang=ts&"
export * from "./TimeSeriesLineChartCard.vue?vue&type=script&lang=ts&"
import style0 from "./TimeSeriesLineChartCard.vue?vue&type=style&index=0&id=2bc15a37&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc15a37",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VCardText,VRow,VSwitch})
